import { useState, useEffect, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { salidasApi, salidaDocumentosApi } from '../api/salidas'
import { remitosApi, notasEnvioApi } from '../api/remitos'
import { fmtFecha, fmtFechaHora } from '../utils/fecha'
import { copiarTexto } from '../utils/copiar'
import { comprimirImagen } from '../utils/imagen'
import { descargarArchivo } from '../utils/descargar'
import { etiquetaCliente } from '../utils/cliente'
import Boton from '../components/Boton'
import SalidaCostoAndreani from '../components/SalidaCostoAndreani'
import api from '../api/client'
import { colors, font } from '../design/tokens'

const ESTADO_SALIDA_LABEL = { armando: 'Armando', despachada: 'En reparto', cerrada: 'Cerrada' }

const ESTADO_ENTREGA_CFG = {
  pendiente:    { bg: '#eff6ff', color: '#1d4ed8', icon: '🚚', label: 'En reparto', soloIcono: false },
  entregado:    { bg: '#16a34a', color: 'white',   icon: '✓',  label: 'Entregado',  soloIcono: true },
  no_entregado: { bg: '#dc2626', color: 'white',   icon: '✕',  label: 'No entregado', soloIcono: true },
  reagendado:   { bg: '#e0e7ff', color: '#3730a3', icon: '↻',  label: 'Reagendado',  soloIcono: false },
}

function EstadoEntregaBadge({ estado }) {
  const cfg = ESTADO_ENTREGA_CFG[estado] || { bg: '#f1f5f9', color: '#475569', icon: '?', label: estado, soloIcono: false }
  // Tildes (entregado/no_entregado): círculo compacto con sólo el ícono.
  if (cfg.soloIcono) {
    return (
      <span
        title={cfg.label}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 26,
          height: 26,
          borderRadius: '50%',
          background: cfg.bg,
          color: cfg.color,
          fontSize: '0.95rem',
          fontWeight: 800,
          lineHeight: 1,
        }}
      >
        {cfg.icon}
      </span>
    )
  }
  return (
    <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: '10px', fontSize: '0.75rem', fontWeight: 600, background: cfg.bg, color: cfg.color }}>
      {cfg.icon} {cfg.label}
    </span>
  )
}

function AccionModal({ doc, tipo, onClose, onDone }) {
  const [form, setForm] = useState({ receptor_nombre: '', motivo_no_entrega: '', nueva_fecha: '', notas: '' })
  const [enviando, setEnviando] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setEnviando(true)
    try {
      if (tipo === 'entregar') {
        await salidaDocumentosApi.entregar(doc.id, { receptor_nombre: form.receptor_nombre, notas: form.notas })
      } else if (tipo === 'no_entregar') {
        await salidaDocumentosApi.noEntregar(doc.id, { motivo_no_entrega: form.motivo_no_entrega, notas: form.notas })
      } else {
        await salidaDocumentosApi.reagendar(doc.id, { nueva_fecha: form.nueva_fecha, notas: form.notas })
      }
      onDone()
    } catch (err) {
      setError(err.response?.data?.message || 'Error al procesar.')
      setEnviando(false)
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: 380, boxShadow: '0 8px 32px rgba(0,0,0,.18)' }}>
        <h2 style={{ fontSize: '1rem', fontWeight: '700', color: '#1e293b', marginBottom: 16 }}>
          {tipo === 'entregar' ? 'Registrar entrega' : tipo === 'no_entregar' ? 'Registrar no entrega' : 'Reagendar'}
        </h2>
        {error && <div style={{ background: '#fee2e2', color: '#991b1b', padding: '8px 12px', borderRadius: 8, marginBottom: 12, fontSize: '0.85rem' }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          {tipo === 'entregar' && (
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>Receptor *</label>
              <input value={form.receptor_nombre} onChange={e => setForm(f => ({ ...f, receptor_nombre: e.target.value }))} style={inp} required placeholder="Nombre de quien recibió" />
            </div>
          )}
          {tipo === 'no_entregar' && (
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>Motivo *</label>
              <input value={form.motivo_no_entrega} onChange={e => setForm(f => ({ ...f, motivo_no_entrega: e.target.value }))} style={inp} required placeholder="Motivo de no entrega" />
            </div>
          )}
          {tipo === 'reagendar' && (
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>Nueva fecha *</label>
              <input type="date" value={form.nueva_fecha} onChange={e => setForm(f => ({ ...f, nueva_fecha: e.target.value }))} style={inp} required />
            </div>
          )}
          <div style={{ marginBottom: 16 }}>
            <label style={lbl}>Notas adicionales</label>
            <textarea value={form.notas} onChange={e => setForm(f => ({ ...f, notas: e.target.value }))} style={{ ...inp, height: 60, resize: 'vertical' }} placeholder="Opcional" />
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <Boton variante="ghost" type="button" onClick={onClose}>Cancelar</Boton>
            <Boton variante="primary" type="submit" disabled={enviando}>
              {enviando ? '...' : 'Confirmar'}
            </Boton>
          </div>
        </form>
      </div>
    </div>
  )
}

export default function SalidaDetallePage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [salida, setSalida] = useState(null)
  const [avisandoTg, setAvisandoTg] = useState(false)
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(null) // { doc, tipo }
  const [liberando, setLiberando]       = useState(null)
  const [reasignando, setReasignando]   = useState(null)
  const [revirtiendo, setRevirtiendo]   = useState(null)
  const [expandidos, setExpandidos] = useState(new Set())

  const toggleExpand = (docId) => {
    setExpandidos(prev => {
      const next = new Set(prev)
      next.has(docId) ? next.delete(docId) : next.add(docId)
      return next
    })
  }

  const expandirTodos = () => setExpandidos(new Set((salida?.documentos || []).map(d => d.id)))
  const colapsarTodos = () => setExpandidos(new Set())

  const cargar = useCallback(async () => {
    try {
      const res = await salidasApi.obtener(id)
      setSalida(res.data)
    } catch {
      setSalida(null)
    } finally {
      setLoading(false)
    }
  }, [id])

  useEffect(() => { cargar() }, [cargar])

  const handleActionDone = () => {
    setModal(null)
    cargar()
  }

  const handleLiberar = async (doc) => {
    if (!window.confirm('¿Liberar este documento? Volverá a estar disponible para asignación.')) return
    setLiberando(doc.id)
    try {
      if (doc.entidad_tipo === 'nota_envio') {
        await notasEnvioApi.liberar(doc.entidad_id)
      } else {
        await remitosApi.liberar(doc.entidad_id)
      }
      cargar()
    } catch (err) {
      alert(err.response?.data?.message || 'Error al liberar.')
    } finally {
      setLiberando(null)
    }
  }

  const handleRevertirEntrega = async (doc) => {
    if (!window.confirm('¿Revertir esta entrega? La parada vuelve a quedar pendiente y la salida se reabre si estaba cerrada.')) return
    setRevirtiendo(doc.id)
    try {
      await salidaDocumentosApi.revertirEntrega(doc.id)
      cargar()
    } catch (err) {
      alert(err.response?.data?.message || 'No se pudo revertir la entrega.')
    } finally {
      setRevirtiendo(null)
    }
  }

  const handleReasignar = async (doc) => {
    if (!window.confirm('¿Volver a poner este documento como disponible para asignar?')) return
    setReasignando(doc.id)
    try {
      if (doc.entidad_tipo === 'nota_envio') {
        await notasEnvioApi.liberar(doc.entidad_id)
      } else {
        await remitosApi.liberar(doc.entidad_id)
      }
      cargar()
    } catch (err) {
      alert(err.response?.data?.message || 'Error al reasignar.')
    } finally {
      setReasignando(null)
    }
  }

  if (loading) return <p style={{ color: '#94a3b8' }}>Cargando...</p>
  if (!salida) return <p style={{ color: '#ef4444' }}>Salida no encontrada.</p>

  const docs = salida.documentos || []
  const entregados = docs.filter(d => d.estado_entrega === 'entregado').length
  const total = docs.length

  return (
    <div style={{ maxWidth: 960, margin: '0 auto' }}>
      {modal && (
        <AccionModal doc={modal.doc} tipo={modal.tipo} onClose={() => setModal(null)} onDone={handleActionDone} />
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <Boton variante="ghost" sm onClick={() => navigate(-1)}>←</Boton>
        <div>
          <h1 style={{ fontSize: '1.4rem', fontWeight: '700', color: '#1e293b' }}>
            Salida #{salida.id} — {salida.fletero?.nombre}
          </h1>
          <p style={{ color: '#64748b', fontSize: '0.875rem' }}>{fmtFecha(salida.fecha)} · {ESTADO_SALIDA_LABEL[salida.estado] || salida.estado}</p>
        </div>
      </div>

      {/* Progreso */}
      <div style={{ background: '#fff', borderRadius: 12, padding: 18, marginBottom: 20, boxShadow: '0 1px 4px rgba(0,0,0,.06)', display: 'flex', alignItems: 'center', gap: 20 }}>
        <div style={{ flex: 1 }}>
          <p style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: '600', marginBottom: 6 }}>Progreso de entregas</p>
          <div style={{ background: '#f1f5f9', borderRadius: 99, height: 10, overflow: 'hidden' }}>
            <div style={{ height: '100%', borderRadius: 99, background: '#22c55e', width: total ? `${(entregados / total) * 100}%` : '0%', transition: 'width .4s' }} />
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <span style={{ fontSize: '1.5rem', fontWeight: '800', color: '#22c55e' }}>{entregados}</span>
          <span style={{ fontSize: '1rem', color: '#94a3b8' }}>/{total}</span>
        </div>
      </div>

      {/* Costo de la salida + Andreani en lote (3 oct 2026) */}
      <SalidaCostoAndreani key={`${salida.id}-${salida.costo}`} salida={salida} onCambio={cargar} />

      {/* Token para fletero */}
      {salida.token_acceso && (
        <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12, padding: 14, marginBottom: 20, display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{ flex: 1 }}>
            <p style={{ fontSize: '0.8rem', fontWeight: '700', color: '#1e40af', marginBottom: 4 }}>Enlace para el fletero (móvil)</p>
            <code style={{ fontSize: '0.8rem', color: '#475569', wordBreak: 'break-all' }}>
              {window.location.origin}/fletero/salida/{salida.token_acceso}
            </code>
          </div>
          <Boton
            variante="secondary"
            sm
            onClick={() => copiarTexto(`${window.location.origin}/fletero/salida/${salida.token_acceso}`)}
          >
            Copiar
          </Boton>
          {/* WhatsApp: el camino de siempre para pasarle la hoja de ruta al
              fletero, con su teléfono y el link ya escritos (mismo botón que
              el listado de Distribución). Conviven los dos (Martin, 28 ago). */}
          <Boton
            variante="send"
            sm
            title={`Enviar la hoja de ruta por WhatsApp a ${salida.fletero?.nombre || 'el fletero'}`}
            onClick={() => {
              const tel = (salida.fletero?.telefono || '').replace(/\D/g, '')
              const destino = tel ? (tel.startsWith('54') ? tel : `54${tel}`) : ''
              const msg = `Hola ${salida.fletero?.nombre || ''}, esta es tu hoja de ruta de hoy:\n${window.location.origin}/fletero/salida/${salida.token_acceso}`
              window.open(
                destino ? `https://wa.me/${destino}?text=${encodeURIComponent(msg)}` : `https://wa.me/?text=${encodeURIComponent(msg)}`,
                '_blank',
              )
            }}
          >
            📱 WhatsApp
          </Boton>
          {/* Telegram (27 ago 2026): si el fletero está vinculado, el link le
              llegó solo al despachar; acá se reenvía (cambió el fletero,
              borró el mensaje). Sin vínculo, se sigue copiando a mano. */}
          <Boton
            variante="secondary"
            sm
            disabled={!salida.fletero?.telegram_chat_id || avisandoTg}
            title={salida.fletero?.telegram_chat_id
              ? 'Mandar la hoja de ruta al Telegram del fletero'
              : 'El fletero no tiene Telegram vinculado (LOGÍSTICA → Fleteros → Vincular Telegram)'}
            onClick={async () => {
              setAvisandoTg(true)
              try {
                await api.post(`/salidas/${salida.id}/avisar-fletero`)
                window.alert('📲 Hoja de ruta enviada al Telegram del fletero.')
              } catch (err) {
                window.alert(err.response?.data?.message || 'No se pudo enviar por Telegram.')
              } finally { setAvisandoTg(false) }
            }}
          >
            📲 Telegram
          </Boton>
          <Boton
            variante="secondary"
            sm
            title="PDF para imprimir: paradas + firma + QR que abre esta misma hoja de ruta en el celular"
            onClick={() => descargarArchivo(`/salidas/${salida.id}/hoja-ruta`, `hoja_ruta_salida_${salida.id}.pdf`)}
          >
            🖨 Hoja de ruta
          </Boton>
        </div>
      )}

      {/* Lista de documentos */}
      <div style={st.docsCard}>
        <div style={st.docsHeaderRow}>
          <h2 style={st.docsTitle}>Documentos ({total})</h2>
          {docs.length > 0 && (
            <div style={{ display: 'flex', gap: 6 }}>
              <Boton variante="secondary" sm type="button" onClick={expandirTodos}>Expandir todos</Boton>
              <Boton variante="secondary" sm type="button" onClick={colapsarTodos}>Colapsar todos</Boton>
            </div>
          )}
        </div>
        {docs.map(doc => {
          const entidad = doc.entidad || {}
          const esNE = doc.entidad_tipo === 'nota_envio'
          const esPending = doc.estado_entrega === 'pendiente' || !doc.estado_entrega
          const esLiberable = esPending && ['asignado', 'en_distribucion'].includes(entidad.estado)
          const open = expandidos.has(doc.id)

          // Datos comunes
          const cliente = esNE ? entidad.remito?.cliente : entidad.cliente
          const dest = esNE ? entidad.destinatario : null
          const persona = esNE ? (dest?.nombre || '—') : etiquetaCliente(cliente)
          const articulos = entidad.articulos || []
          const totalUnidades = articulos.reduce((acc, a) => acc + Number(a.cantidad || 0), 0)
          const zona = entidad.zona?.nombre

          // Dirección de ENTREGA. Para T90 prioriza nv.direccion_envio
          // (Magento manda shipping aparte de billing); si no hay, el
          // domicilio del cliente (= billing, lo de Presea para la factura).
          const env = !esNE ? (entidad.nota_venta?.direccion_envio || entidad.direccion_envio) : null
          const tieneEnvio = env && (env.calle || env.localidad || env.codigo_postal)
          const calle = esNE ? dest?.calle : (tieneEnvio ? env.calle : cliente?.domicilio)
          const localidad = esNE ? dest?.localidad : (tieneEnvio ? env.localidad : cliente?.localidad)
          const provincia = esNE ? dest?.provincia : (tieneEnvio ? env.provincia : cliente?.provincia)
          const cp = esNE ? dest?.codigo_postal : (tieneEnvio ? env.codigo_postal : cliente?.codigo_postal)
          const tel = esNE ? dest?.telefono : (tieneEnvio ? env.telefono : cliente?.telefono)
          const dirLinea = [calle, localidad, provincia].filter(Boolean).join(', ')

          // NE-specifics
          const fechaEnt = esNE ? entidad.fecha_entrega_est : null
          const hd = esNE ? entidad.hora_desde : null
          const hh = esNE ? entidad.hora_hasta : null
          const obs = esNE ? dest?.notas : entidad.observaciones_raw
          const nv = esNE ? entidad.remito?.nota_venta : entidad.nota_venta
          const remitoPadre = esNE ? entidad.remito : null

          return (
            <div key={doc.id} style={st.docRow}>
              {/* === Encabezado: dos líneas, cliente y dirección SIEMPRE
                   visibles (antes había que expandir para saber a dónde iba) === */}
              <div style={st.docHeader} onClick={() => toggleExpand(doc.id)} title={open ? 'Colapsar' : 'Ver el detalle'}>
                <div style={st.headerMain}>
                  <div style={st.headerTop}>
                    <span style={{ ...st.arrow, transform: open ? 'rotate(90deg)' : 'rotate(0deg)' }}>▶</span>
                    <span style={{ ...st.tipoBadge, ...(esNE ? st.tipoNE : st.tipoR90) }}>
                      {esNE ? 'NE' : 'Re'}
                    </span>
                    <button
                      type="button"
                      style={st.numeroLink}
                      title={esNE ? 'Abrir la nota de envío' : 'Abrir el remito'}
                      onClick={e => { e.stopPropagation(); navigate(esNE ? `/notas-envio/${entidad.id}` : `/remitos/${entidad.id}`) }}
                    >
                      {esNE ? entidad.numero_ne : entidad.numero_presea} ↗
                    </button>
                    {doc.estado_entrega
                      ? <EstadoEntregaBadge estado={doc.estado_entrega} />
                      : salida.estado === 'armando'
                        ? <span style={st.armandoTag}>En armado</span>
                        : <EstadoEntregaBadge estado="pendiente" />
                    }
                  </div>
                  <div style={st.headerSub}>
                    <span style={st.subPersona}>{persona}</span>
                    {dirLinea && <span style={st.subDir}>📍 {dirLinea}{cp ? ` (CP ${cp})` : ''}</span>}
                    {zona && <span style={st.zonaPill}>{zona}</span>}
                  </div>
                </div>
                <div style={st.acciones} onClick={e => e.stopPropagation()}>
                  {esPending && salida.estado === 'despachada' && (
                    <>
                      <Boton variante="success" sm onClick={() => setModal({ doc, tipo: 'entregar' })}>Entregado</Boton>
                      <Boton variante="destructive" sm onClick={() => setModal({ doc, tipo: 'no_entregar' })}>No entregado</Boton>
                      <Boton variante="secondary" sm onClick={() => setModal({ doc, tipo: 'reagendar' })}>Reagendar</Boton>
                    </>
                  )}
                  {esPending && esLiberable && (
                    <Boton
                      variante="secondary"
                      sm
                      onClick={() => handleLiberar(doc)}
                      disabled={liberando === doc.id}
                      title="Devuelve el documento al estado disponible"
                    >
                      {liberando === doc.id ? '...' : 'Liberar'}
                    </Boton>
                  )}
                  {['no_entregado', 'reagendado'].includes(doc.estado_entrega) && (
                    <Boton
                      variante="secondary"
                      sm
                      onClick={() => handleReasignar(doc)}
                      disabled={reasignando === doc.id}
                    >
                      {reasignando === doc.id ? '...' : 'Volver a asignar'}
                    </Boton>
                  )}
                  {doc.estado_entrega === 'entregado' && (
                    <Boton
                      variante="destructive"
                      sm
                      onClick={() => handleRevertirEntrega(doc)}
                      disabled={revirtiendo === doc.id}
                      title="Devuelve la parada a pendiente (entrega marcada por error)"
                    >
                      {revirtiendo === doc.id ? '...' : '↩ Revertir entrega'}
                    </Boton>
                  )}
                </div>
              </div>

              {/* === Detalle expandido === */}
              {open && (
                <div style={st.docDetalle}>
                  <div style={st.docBody}>
                    <div style={st.docCol}>
                      <div style={st.persona}>
                        <strong>{persona}</strong>
                        {!esNE && cliente?.cuit && <span style={st.cuit}>CUIT {cliente.cuit}</span>}
                      </div>
                      {dirLinea && <div style={st.dir}>📍 {dirLinea}</div>}
                      {tel && <div style={st.contactRow}><span style={st.chipTel}>📞 {tel}</span></div>}
                    </div>
                    <div style={st.docColRight}>
                      {!esNE && entidad.numero_presea && (
                        <div style={st.refTag}>Remito <button style={st.linkInline} onClick={() => navigate(`/remitos/${entidad.id}`)}>{entidad.numero_presea}</button></div>
                      )}
                      {esNE && (
                        <div style={st.refTag}>Nota de envío <button style={st.linkInline} onClick={() => navigate(`/notas-envio/${entidad.id}`)}>{entidad.numero_ne}</button></div>
                      )}
                      {esNE && remitoPadre?.numero_presea && (
                        <div style={st.refTag}>Remito padre <button style={st.linkInline} onClick={() => navigate(`/remitos/${remitoPadre.id}`)}>{remitoPadre.numero_presea}</button></div>
                      )}
                      {nv && <div style={st.refTag}>NV <button style={st.linkInline} onClick={() => navigate(`/notas-venta/${nv.id}`)}>{nv.numero_lgr}</button></div>}
                      {fechaEnt && <div style={st.fechaTag}>Fecha entrega: <strong>{fmtFecha(fechaEnt)}</strong></div>}
                      {(hd || hh) && <div style={st.fechaTag}>Horario: <strong>{hd || '—'} a {hh || '—'}</strong></div>}
                    </div>
                  </div>

                  {articulos.length > 0 && (
                    <div style={st.articulosBlock}>
                      <div style={st.articulosTitle}>Artículos · {totalUnidades} unid.</div>
                      <table style={st.artTable}>
                        <tbody>
                          {articulos.map(a => (
                            <tr key={a.id} style={st.artTr}>
                              <td style={st.artTdCodigo}>{a.articulo?.codigo_alfa}</td>
                              <td style={st.artTdDesc}>{a.articulo?.descripcion}</td>
                              <td style={st.artTdCant}>× {a.cantidad}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {obs && <div style={st.obsBlock}>💬 {obs}</div>}

                  {(doc.receptor_nombre || doc.motivo_no_entrega || doc.nueva_fecha || doc.entregado_at) && (
                    <div style={st.resultadoBlock}>
                      {doc.entregado_at && <span style={st.resFecha}>🕐 {doc.estado_entrega === 'entregado' ? 'Entregado el' : 'Registrado el'} <strong>{fmtFechaHora(doc.entregado_at)}</strong></span>}
                      {doc.receptor_nombre && <span style={st.resOk}>✓ Recibió: <strong>{doc.receptor_nombre}</strong></span>}
                      {doc.motivo_no_entrega && <span style={st.resErr}>✕ Motivo: <strong>{doc.motivo_no_entrega}</strong></span>}
                      {doc.nueva_fecha && <span style={st.resReag}>↻ Reagendado: <strong>{fmtFecha(doc.nueva_fecha)}</strong></span>}
                      {doc.notas && <div style={st.docNotas}>{doc.notas}</div>}
                      {/* Sug #60: el remito firmado vuelve en papel con el
                          fletero — se adjunta acá, con la entrega ya marcada.
                          Va al mismo campo `imagenes` que las fotos del
                          fletero: es el respaldo documental de ESTA entrega. */}
                      <AdjuntarFirmado salida={salida} doc={doc} onSubida={cargar} />
                    </div>
                  )}
                </div>
              )}
            </div>
          )
        })}
        {docs.length === 0 && (
          <p style={{ padding: '30px 18px', color: '#94a3b8', textAlign: 'center' }}>Sin documentos.</p>
        )}
      </div>
    </div>
  )
}

const lbl = { display: 'block', fontSize: '0.8rem', fontWeight: '600', color: '#475569', marginBottom: 4 }
const inp = { width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: '0.875rem', boxSizing: 'border-box' }

const st = {
  docsCard: { background: '#fff', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,.06)', overflow: 'hidden' },
  docsHeaderRow: { padding: '12px 18px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.75rem' },
  docsTitle: { fontSize: '0.85rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', margin: 0 },
  docRow: { borderBottom: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column' },

  docHeader: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '0.75rem', padding: '10px 18px', cursor: 'pointer', flexWrap: 'wrap' },
  headerMain: { display: 'flex', flexDirection: 'column', gap: '0.25rem', minWidth: 0, flex: '1 1 340px' },
  headerTop: { display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap' },
  headerSub: { display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap', paddingLeft: 22, fontSize: '0.8125rem' },
  subPersona: { fontWeight: 600, color: '#1e293b', maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  subDir: { color: '#64748b', minWidth: 0 },
  arrow: { color: '#94a3b8', fontSize: '0.7rem', transition: 'transform 0.15s ease', display: 'inline-block', width: 12 },
  zonaPill: { fontSize: '0.7rem', color: '#475569', background: '#f1f5f9', padding: '1px 7px', borderRadius: 8, fontWeight: 600, whiteSpace: 'nowrap' },
  armandoTag: { display: 'inline-block', padding: '2px 10px', borderRadius: '10px', fontSize: '0.75rem', fontWeight: 600, background: '#f1f5f9', color: '#94a3b8', fontStyle: 'italic' },
  docDetalle: { padding: '0 18px 14px 40px', display: 'flex', flexDirection: 'column', gap: '0.625rem', background: '#fafbfc' },
  refTag: { fontSize: '0.75rem', color: '#475569', display: 'flex', alignItems: 'center', gap: '0.3rem' },
  tipoBadge: { fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', padding: '2px 8px', borderRadius: 4, textAlign: 'center' },
  tipoNE: { color: colors.t80Text, background: colors.t80Bg },
  tipoR90: { color: colors.t90Text, background: colors.t90Bg },
  numeroLink: { fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', fontWeight: 700, fontSize: '0.875rem', color: colors.link, background: '#f1f5f9', padding: '2px 8px', borderRadius: 4, whiteSpace: 'nowrap', border: 'none', cursor: 'pointer' },
  linkInline: { background: 'none', border: 'none', padding: 0, color: colors.link, fontWeight: 700, cursor: 'pointer', fontFamily: font.mono, textDecoration: 'underline', fontSize: '0.75rem' },

  acciones: { display: 'flex', gap: '0.4rem', flexShrink: 0, flexWrap: 'wrap', justifyContent: 'flex-end', marginLeft: 'auto' },

  docBody: { display: 'grid', gridTemplateColumns: '1fr auto', gap: '0.75rem', alignItems: 'start' },
  docCol: { display: 'flex', flexDirection: 'column', gap: '0.3rem', minWidth: 0 },
  docColRight: { display: 'flex', flexDirection: 'column', gap: '0.3rem', alignItems: 'flex-end' },

  persona: { fontSize: '0.9rem', color: '#1e293b' },
  cuit: { marginLeft: '0.5rem', fontSize: '0.75rem', color: '#64748b', fontFamily: font.mono, fontVariantNumeric: 'tabular-nums' },
  dir: { fontSize: '0.825rem', color: '#475569' },
  contactRow: { display: 'flex', gap: '0.5rem', flexWrap: 'wrap' },
  chip: { fontSize: '0.7rem', fontWeight: 700, color: '#1e40af', background: '#eff6ff', padding: '0.1rem 0.5rem', borderRadius: 8, border: '1px solid #bfdbfe' },
  chipTel: { fontSize: '0.7rem', color: '#475569', background: '#f1f5f9', padding: '0.1rem 0.5rem', borderRadius: 8, fontWeight: 600 },

  zonaTag: { fontSize: '0.75rem', color: '#475569' },
  fechaTag: { fontSize: '0.75rem', color: '#475569' },
  nvTag: { fontSize: '0.75rem', color: '#475569', display: 'flex', alignItems: 'center', gap: '0.3rem' },

  articulosBlock: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 7, padding: '0.5rem 0.75rem' },
  articulosTitle: { fontSize: 11, fontWeight: 600, color: colors.textSec, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.4rem' },
  artTable: { width: '100%', borderCollapse: 'collapse' },
  artTr: { borderTop: '1px solid #eef2f7' },
  artTdCodigo: { fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', fontWeight: 700, color: colors.text, fontSize: '0.75rem', padding: '4px 10px 4px 0', whiteSpace: 'nowrap', width: 110, verticalAlign: 'top' },
  artTdDesc: { color: colors.textSec, fontSize: '0.8125rem', padding: '4px 10px 4px 0' },
  artTdCant: { fontWeight: 600, color: colors.text, fontSize: '0.8125rem', padding: '4px 0', textAlign: 'right', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums', width: 60, verticalAlign: 'top' },

  obsBlock: { fontSize: '0.8125rem', color: '#92400e', background: '#fefce8', border: '1px solid #fde68a', borderRadius: 6, padding: '0.45rem 0.625rem' },

  resultadoBlock: { display: 'flex', flexDirection: 'column', gap: '0.25rem', fontSize: '0.8125rem', background: '#f8fafc', borderRadius: 6, padding: '0.45rem 0.625rem' },
  resFecha: { color: '#475569', fontWeight: 600 },
  resOk: { color: '#166534' },
  resErr: { color: '#991b1b' },
  resReag: { color: '#3730a3' },
  docNotas: { fontSize: '0.75rem', color: '#64748b', fontStyle: 'italic' },
}


/**
 * Adjuntar el remito FIRMADO a un documento ya entregado (sug #60, Diego
 * Gorfinkiel): el papel firmado vuelve al depósito con el fletero y recién ahí
 * se escanea — el respaldo documental no puede depender del momento exacto del
 * registro. Muestra también cuántos adjuntos tiene la entrega.
 */
function AdjuntarFirmado({ salida, doc, onSubida }) {
  const [subiendo, setSubiendo] = useState(false)
  const [msg, setMsg] = useState('')
  const cantFotos = (doc.imagenes || []).length

  const elegir = async (e) => {
    const files = e.target.files
    if (!files?.length) return
    setSubiendo(true); setMsg('')
    try {
      const imagenes = await Promise.all(Array.from(files).map(f => comprimirImagen(f)))
      await salidaDocumentosApi.subirImagenes(salida.id, doc.id, imagenes)
      setMsg('✓ Adjuntado')
      onSubida?.()
    } catch {
      setMsg('Error al adjuntar. Reintentá.')
    } finally {
      setSubiendo(false)
      e.target.value = ''
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2 }}>
      <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#1e40af', cursor: 'pointer' }}>
        📷 {subiendo ? 'Adjuntando…' : 'Adjuntar remito firmado'}
        <input type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={elegir} disabled={subiendo} />
      </label>
      {cantFotos > 0 && (
        <span style={{ fontSize: '0.72rem', color: '#64748b' }}>
          {cantFotos} adjunto{cantFotos > 1 ? 's' : ''}
        </span>
      )}
      {msg && <span style={{ fontSize: '0.72rem', color: msg.startsWith('✓') ? '#166534' : '#991b1b' }}>{msg}</span>}
    </div>
  )
}
